import { useState } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddQrCodeGroupingModal from "./AddQrCodeGroupingModal";
import QrCodeGroupingService from "../../../../services/QrCodeGroupingService";
import { usePermissions } from "../../../common/permissions";

const QrCodeGrouping = () => {
	const [data, setData] = useState(null);
	const [addModal, setAddModal] = useState(false);
	const [hasData, setHasData] = useState(null);
	const [item, setItem] = useState({});
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const qrCodeGroupingService = new QrCodeGroupingService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canAdd } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);
	const search = useSelector((state) => state.auth.search);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].qr_code_grouping}
						</span>
					</div>
					<div className="add-admin">
						{canAdd("qr_code_grouping") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setItem({});
									setAddModal(true);
								}}>
								<i
									className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.qr_code_grouping}
							</Button>
						)}
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.zone}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.quantity}</strong>
									</th>

									<th>
										<strong>{Translate[lang]?.price}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price_per}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
												setItem={setItem}
												setAddModal={setAddModal}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={qrCodeGroupingService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
					/>
				</div>
			</div>
			{addModal && (
				<AddQrCodeGroupingModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					item={item}
				/>
			)}
		</div>
	);
};
export default QrCodeGrouping;
